var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"rfcview"}},[_c('ag-grid-vue',{staticClass:"ag-theme-balham",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"rfcvue","gridOptions":_vm.gridOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }